import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const heroImage = "/images/firstgivinghero-2.webp";

export const Hero = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/auth', { state: { defaultTab: 'signup', defaultUserType: 'fundraiser' } });
  };

  return (
    <section className="relative pt-20 sm:pt-28 md:pt-32 lg:pt-40 pb-6 sm:pb-8 md:pb-12 lg:pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-background to-primary/10 -z-10" />
      <div
        className="pointer-events-none absolute inset-0 -z-10 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(currentColor 1px, transparent 1px), linear-gradient(90deg, currentColor 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />
      <div className="pointer-events-none absolute -top-24 -right-24 w-96 h-96 rounded-full bg-primary/20 blur-3xl -z-10" />
      <div className="pointer-events-none absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-emerald-400/20 blur-3xl -z-10" />
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 max-w-7xl relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Left Column - Text Content */}
          <div className="max-w-3xl text-left space-y-5 sm:space-y-6 md:space-y-8 animate-fade-in">
            <div className="inline-flex items-center gap-3">
              <span className="h-px w-8 bg-primary/60" />
              <span className="text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase text-primary">
                FirstGiving · UK fundraising
              </span>
              <span className="h-px w-8 bg-primary/60" />
            </div>
            <h1 className="text-[2.5rem] leading-[1.05] sm:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight text-foreground">
              Fundraising{" "}
              <span className="font-serif italic font-medium text-foreground/90">that actually</span>{" "}
              <span className="relative inline-block">
                <span className="relative z-10 bg-gradient-to-r from-primary to-emerald-500 bg-clip-text text-transparent">
                  reaches
                </span>
                <span className="absolute left-0 right-0 bottom-1 h-3 sm:h-4 bg-primary/15 -z-0 rounded-sm -skew-x-6" />
              </span>{" "}
              people.
            </h1>

            <p className="text-base sm:text-lg md:text-xl text-muted-foreground max-w-xl leading-relaxed">
              The UK platform built for causes that matter — zero platform fees, real human support, and donations that arrive where they're meant to go.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 items-stretch sm:items-start">
              <Button 
                variant="default" 
                size="lg" 
                className="rounded-full px-6 sm:px-8 h-[50px] w-full sm:w-auto sm:min-w-[200px]"
                onClick={handleGetStarted}
              >
                Get Started
              </Button>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="flex justify-center lg:justify-end items-center mt-8 lg:mt-0">
            <img 
              src={heroImage} 
              alt="Crowdfunding community illustration" 
              width="650"
              height="405"
              {...({ fetchpriority: "high" } as any)}
              className="w-full max-w-[350px] sm:max-w-[450px] md:max-w-[550px] lg:max-w-[650px] h-auto animate-fade-in object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
